import * as React from "react";
import { FormComponent } from "../../../../react-core/Html/FormComponent";
import { SelectEditor } from "../../../../react-core/Html/SelectEditor";
import { CommonHelper } from "../../../../react-core/Helpers/CommonHelper";
import { TextBoxEditor } from "../../../../react-core/Html/TextBoxEditor";
import { ContentFilter, NetworkTypeOptions, errorMsg } from "../Resource/Content";
import { NoSpecial, Numeric } from "../../../../react-core/Html/Validation/RegExPatterns";
import { ValidatorContents } from "../../../Dashboard/Common/ValidatorHelper";
import { AlphanumericWithSpecialCharacters } from "../../../../react-core/Html/Validation/RegExPatterns";

interface INetworkFilterDashboardProps {
    filter: any;
    handleFilterChange: (changes) => void;
    onSearch: VoidFunction;
}

interface INetworkFilterDashboardState {}

export class NetworkFilterDashboard extends FormComponent<INetworkFilterDashboardProps, INetworkFilterDashboardState> {
    constructor(props: INetworkFilterDashboardProps) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        return <>{this.renderFilters()}</>;
    }

    private renderFilters(): JSX.Element {
        const { NetworkId, NetworkType, NetworkName, TradingReference, PostCode } = this.props.filter;
        const { handleFilterChange } = this.props;
        return (
            <>
                <h1 className="page-heading">{ContentFilter.title.title}</h1>
                <div className="row narrow-gutter">
                    <div className="col-12 col-sm-4">
                        <TextBoxEditor
                            value={NetworkId}
                            label={ContentFilter.search.networkId}
                            onChange={(v) => handleFilterChange({ NetworkId: v })}
                        />
                    </div>
                    <div className="col-12 col-sm-4">
                        <SelectEditor
                            label={ContentFilter.search.networkType}
                            selected={NetworkType}
                            options={NetworkTypeOptions.map((item) => item.key)}
                            getText={(key) => CommonHelper.getOptionsTxt(key, NetworkTypeOptions)}
                            onChange={(v) => handleFilterChange({ NetworkType: v })}
                        />
                    </div>
                    <div className="col-12 col-sm-4">
                        <TextBoxEditor
                            value={NetworkName}
                            label={ContentFilter.search.networkName}
                            maxLength={50}
                            regex={{ errorMessage: ValidatorContents.AlphaNumericWithSpecialCharacters,
                                value: AlphanumericWithSpecialCharacters, }}
                            onChange={(v) => handleFilterChange({ NetworkName: v })}
                        />
                    </div>
                    <div className="col-12 col-sm-4">
                        <TextBoxEditor
                            value={TradingReference}
                            label={ContentFilter.search.reference}
                            onChange={(v) => handleFilterChange({ TradingReference: v })}
                            maxLength={8}
                            regex={{ errorMessage: "Must be numeric characters only", value: Numeric }}
                        />
                    </div>
                    <div className="col-12 col-sm-4">
                        <TextBoxEditor
                            value={PostCode}
                            label={ContentFilter.search.postCode}
                            regex={{ errorMessage: errorMsg.noSpecial, value: NoSpecial }}
                            onChange={(v) => handleFilterChange({ PostCode: v })}
                        />
                    </div>
                    <div className="col-auto col-bottom">
                        <div className="form-group">
                            <div className="controls">
                                <button
                                    className="btn secondary"
                                    onClick={() => {
                                        if (this.isValid()) {
                                            this.props.onSearch();
                                        }
                                    }}
                                >
                                    {ContentFilter.title.search}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
